module.exports = {
  DEFAULT_PROJECTION: 'globe',
  DEFAULT_STYLE: 'OSM',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_3D_BUILDINGS: true
};
